export const DEFAULT_ZONE_NAME = "DEFAULT";
export const DEFAULT_FLOOR_NAME = "DEFAULT";

export interface Zone {
  zone_id: number;
  zone_name: string;

  property_id: number;
  floor: string;
  extra_data?: null | { isAlen?: boolean };
}

export interface AlenRoom {
  room_id: number;
  name: string;
}

export interface Floor {
  name: string;
  alenId?: number; // alen room is taken as floor therefore it sometimes has id
}
